module.exports = __webpack_public_path__ + "static/media/logo-light.d81b0cab.svg";